<template>
  <div>

    <div class="row mt-1 ml-0">
      <a class="btn-link smaller" href="#"
            @click="addLead">
        <i class="fa fa-plus"></i> Add Lead
      </a>
    </div>

    <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave"
              @row-click="rowClick"
              id="leadsTable" class="table-striped" 
              :data="leads" :row-class-name="rowClasses">

      <el-table-column prop="id" label="ID" width="100">
        <template slot-scope="{row}">
        {{ row.incentifyerAccountId+'-'+row.id }}
        </template>
      </el-table-column>

      <el-table-column prop="name" label="Name" width="140"/>

      <el-table-column label="Affiliate">
        <template slot-scope="{row}">
          {{ getAffiliateName(row.affiliateAccountId) }}
        </template>
      </el-table-column>

      <el-table-column label="Incentifyer">
        <template slot-scope="{row}">
          {{ getIncentifyerName(row.incentifyerAccountId) }}
        </template>
      </el-table-column>

      <el-table-column label="Status" width="100">
        <template slot-scope="{row}">
          {{ getStatusLabel(row.status) }}
        </template>
      </el-table-column>

      <el-table-column label="Date" width="120">
        <template slot-scope="{row}">
          {{ getLeadDate(row) }}
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :affiliateCompanyId="row.incentifyerAccountId+'-'+row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import utils from '../../utils'
export default {
    name: 'Leads-Table',
    props: {
      // hidePosition:       {type: Boolean, default: false},
      // hideCompany:        {type: Boolean, default: false},
      // hideLeadsReceived:  {type: Boolean, default: false},
      // hideLeadsClosed:    {type: Boolean, default: false},
      // hideLeads:          {type: Boolean, default: false},
      // hidePayouts:        {type: Boolean, default: false},
      // hideCloseRate:      {type: Boolean, default: false},
      // forCompany:         {type: Object, default: null}
    },
    mounted () {
      this.$store.dispatch('fetchDataset')
      this.$store.dispatch('fetchBaseData')
    },
    computed: {
      leads () {
        return this.$store.getters.leads || []
      }
    },
    methods: {
      getLeadDate (lead) {
        const Lead = this.$store.getters.Lead
        switch (lead.status) {
          case Lead._status.RECEIVED.value: return utils.dateToString(lead.dateReceived);
          case Lead._status.CLOSED.value:   return utils.dateToString(lead.dateClosed);
          case Lead._status.LOST.value:     return utils.dateToString(lead.dateLost);
          default:                          return '-'
        }
      },
      addLead () {
        alert(`Not yet implemented`)
      },
      getAffiliateCompanyName (affiliateAccountId) {
        const company = this.$store.getters.affiliateCompanies.find(c => c.id == affiliateAccountId)
        if (company && company.profile)
          return company.profile.companyName || '-'
        else
          return '-'
      },
      getAffiliate(id) {
        return this.$store.getters.users.find(a => a.id == id
                                         && a.type == 'affiliate') || {}
      },
      getAffiliateName (affiliateAccountId) {
        const affiliate = this.getAffiliate(affiliateAccountId)
        if (affiliate)
          return affiliate.firstName + ' ' + affiliate.lastName
        else
          return '-'
      },
      getIncentifyerName (incentifyerAccountId) {
        const incentifyer = this.$store.getters.incentifyerAccounts.find(a => a.id == incentifyerAccountId)
        return incentifyer && incentifyer.profile ? incentifyer.profile.companyName || '-' : '-'
      },
      getStatusLabel (statusValue) {
      const statusObj = Object.entries(this.$store.getters.Lead._status).find(e => e[1].value == statusValue)[1]
      return statusObj ? statusObj.label : statusValue
      },

      rowClasses ({row, rowIndex}) {
        return row.archived?'archivedTableRow clickableRow':'clickableRow'
      },
      rowHover(row, column, cell, event) {
        // We show all buttons of class .showOnHover
        var rows = $('#affiliatesTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var foundRow = JSON.stringify($(rows[i]).html().indexOf('affiliateid="'+row.incentifyerAccountId+'-'+row.id+'"')) > -1
          var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
          if (foundRow && !archivedRow) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).removeClass('d-none')
            }
            break
          }
        }
      },
      rowHoverLeave (row, column, cell, event) {
        // We hide all buttons of class .showOnHover
        var rows = $('#affiliatesTable > div > table > tbody > tr')
        for (var i = 0; i < rows.length; i++) {
          var index = JSON.stringify($(rows[i]).html().indexOf('affiliateid="'+row.incentifyerAccountId+'-'+row.id+'"'))
          if (index > -1) {
            var icons = $(rows[i]).find('.showOnHover')
            for (var j = 0; j < icons.length; j++) {
              $(icons[j]).addClass('d-none')
            }
            break
          }
        }
      },
      rowClick (row, column, event) {
        // We check to see if the click happened on an icon button
        // var match = JSON.stringify(event.toElement.classList.value).match(/fa[rsdl]{0,1}\sfa-/i)
        var path = event.path || event.composedPath() // 2nd one if for Firefox
        var match = JSON.stringify(path[0].className).match(/fa[rsdl]{0,1}\sfa-/i)
        if (match && match.index > -1) {
          // icon button, we ignore row click
        } else {
          //console.log('row click')
          this.editAffiliate(row)
        }
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>